<template>
  <div>
    <AccordionCard :state="cards.salesRoofSidesAttachments">
      <template v-slot:header>
        {{ $t('roofSidesAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('roofSidesAttachments') }}
        </div>

        <div class="flex-column select">
          <p>
            {{ $t('roofSidesAttachments_description') }}
          </p>
          <div>
            {{ $t('templateAttachments') }}:
            <AttachmentGallery
              :attachments="referenceData.reportTemplateImages[18].templateAttachments"
              :deletable="false"
              :sortByName="false"
              :showFilename="false"
            ></AttachmentGallery>
          </div>
        </div>
      </div>

      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.salesRoofSidesAttachments"
            attachmentType="salesRoofSidesAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="isSalesRoofSidesAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="salesRoofSidesAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isSalesRoofSidesAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { AccessBlockMixin } from '@/mixins/accessBlock';
import AccordionCard from '@/components/AccordionCard';
import DropzoneUpload from '@/components/DropzoneUpload';
import AttachmentGallery from '@/components/AttachmentGallery';

export default {
  name: 'SalesRoofLayout',
  components: {
    AccordionCard,
    DropzoneUpload,
    AttachmentGallery,
  },
  mixins: [AccessBlockMixin],
  props: {
    project: { type: Object },
    cards: { type: Object },
    /**
     * Template images from `MobileProjectsSalesReport` (block field, or the store getter outside
     * the block).
     */
    referenceData: { type: Object, default: () => ({ reportTemplateImages: [] }) },
  },
  data() {
    return {
      /** track Upload states for clearing dropzone preview */
      isSalesRoofSidesAttachmentsUploadComplete: false,
    };
  },
  computed: {
    ...mapGetters(['getEnumValues']),
    ...mapGetters('auth', ['isOrganizationRoleNavigationEnabled']),
  },

  methods: {
    ...mapActions(['uploadProjectAttachment', 'deleteProjectAttachment']),

    async onUploadProjectAttachment(payload) {
      await this.uploadProjectAttachment(payload);
    },

    async onDeleteProjectAttachment(event) {
      await this.deleteProjectAttachment({
        projectId: this.project.id,
        attachmentId: event.attachmentId,
        attachmentType: event.attachmentType,
      });
    },
  },
  async mounted() {
    // after upload is complete emit event to clear dropzone preview
    this.$store.subscribeAction({
      after: (action, state) => {
        if (action.type === 'uploadProjectAttachment') {
          this.isSalesRoofSidesAttachmentsUploadComplete = true;
        }
      },
    });
  },
};
</script>
